import React, { useState } from "react";

import {
  Stack,
  Input,
  FormLabel,
  Checkbox,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import ReusableInput from "components/Inputs/ReusableInput";
import GradientButton from "components/Buttons/GradientButton";


const AddStarterKitComponentDrawer = ({
  isOpen,
  onClose,
  onAddStarterKitComponent,
}) => {

  const [formData, setFormData] = useState({
    component_name: "",
    description: "",
    unit_price: "",
    quantity_in_stock: "",
    minimum_stock_level: "",
    is_mandatory: true,
    active: true,
    display_order: "",
    images: [],
  });


  const handleInputChange = (e) => {
    const {
      name,
      value,
    } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleCheckboxChange = (e) => {
    const {
      name,
      checked,
    } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };


  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      images: Array.from(
        e.target.files || []
      ),
    }));
  };


  const handleSubmit = async () => {

    if (
      !formData.component_name ||
      !formData.unit_price
    ) {
      alert(
        "Please fill all required fields"
      );

      return;
    }


    const formDataToSend =
      new FormData();

    formDataToSend.append(
      "component_name",
      formData.component_name
    );

    formDataToSend.append(
      "description",
      formData.description
    );

    formDataToSend.append(
      "unit_price",
      formData.unit_price
    );

    if (
      formData.quantity_in_stock !== ""
    ) {
      formDataToSend.append(
        "quantity_in_stock",
        formData.quantity_in_stock
      );
    }

    if (
      formData.minimum_stock_level !== ""
    ) {
      formDataToSend.append(
        "minimum_stock_level",
        formData.minimum_stock_level
      );
    }

    formDataToSend.append(
      "is_mandatory",
      formData.is_mandatory
    );

    formDataToSend.append(
      "active",
      formData.active
    );

    if (
      formData.display_order !== ""
    ) {
      formDataToSend.append(
        "display_order",
        formData.display_order
      );
    }


    formData.images.forEach(
      (image) => {
        formDataToSend.append(
          "images",
          image
        );
      }
    );


    try {

      const response =
        await onAddStarterKitComponent(
          formDataToSend
        );

      if (response?.success) {

        setFormData({
          component_name: "",
          description: "",
          unit_price: "",
          quantity_in_stock: "",
          minimum_stock_level: "",
          is_mandatory: true,
          active: true,
          display_order: "",
          images: [],
        });

        onClose();
      }

    } catch (error) {

      console.error(
        "Error submitting Starter Kit Component:",
        error
      );
    }
  };


  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={
        <h2>
          Add Starter Kit Component
        </h2>
      }

      bodyContent={
        <Stack spacing={4}>

          <ReusableInput
            label="Component Name"
            name="component_name"
            value={
              formData.component_name
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter component name"
            isRequired
          />


          <ReusableInput
            label="Description"
            name="description"
            value={
              formData.description
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter component description"
            type="textarea"
          />


          <ReusableInput
            label="Unit Price"
            name="unit_price"
            type="number"
            value={
              formData.unit_price
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter unit price"
            isRequired
          />


          <ReusableInput
            label="Quantity in Stock"
            name="quantity_in_stock"
            type="number"
            value={
              formData.quantity_in_stock
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter quantity"
          />


          <ReusableInput
            label="Minimum Stock Level"
            name="minimum_stock_level"
            type="number"
            value={
              formData.minimum_stock_level
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter minimum stock level"
          />


          <ReusableInput
            label="Display Order"
            name="display_order"
            type="number"
            value={
              formData.display_order
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter display order"
          />


          <Checkbox
            name="is_mandatory"
            isChecked={
              formData.is_mandatory
            }
            onChange={
              handleCheckboxChange
            }
          >
            Mandatory component
          </Checkbox>


          <Checkbox
            name="active"
            isChecked={
              formData.active
            }
            onChange={
              handleCheckboxChange
            }
          >
            Active
          </Checkbox>


          <FormLabel color="gray.400">
            Component Images
          </FormLabel>

          <Input
            type="file"
            name="images"
            accept="image/*"
            multiple
            onChange={
              handleFileChange
            }
            variant="unstyled"
          />

        </Stack>
      }

      footerContent={
        <Stack
          direction="row"
          spacing={4}
          justifyContent="flex-end"
        >

          <GradientButton
            fontSize="15px"
            width="100px"
            height="40px"
            onClick={onClose}
          >
            Cancel
          </GradientButton>

          <GradientButton
            fontSize="15px"
            width="80px"
            height="40px"
            onClick={handleSubmit}
          >
            Save
          </GradientButton>

        </Stack>
      }
    />
  );
};


export default AddStarterKitComponentDrawer;